<template>
<template-content-view>
        <template #left>
            <div class="caption">
                {{ $tr("Онлайн") }}
            </div>
        </template>
        <template #content>
            <table-view :controller="controller" :sortable="true" />
        </template>
    </template-content-view>
</template>

<script>

import { markRaw } from 'vue';

import TableUserValue from '@topomatic/tap/src/components/TableUserValue.vue';
import TableView, {
    TableSimpleController,
} from '@topomatic/tap/src/components/TableView.vue';
import TemplateContentView from '@topomatic/tap/src/components/TemplateContentView.vue';
import TableDateValue from '@topomatic/tap/src/components/TableDateValue.vue';

let gclients = [];

class ClientsController extends TableSimpleController {
    constructor(app) {
        super(app, gclients);
        this.cid = 'clients';
        this.add('Пользователь', 'user', TableUserValue);
        this.add('Приложение', 'client', undefined, '25%').autofilter = true;
        this.add('Устройство', 'device', undefined, '25%').autofilter = true;
        this.add('Дата', 'authorized', TableDateValue, '10%').order = -1;
        this.add('Адрес', 'ip', undefined, '10%').autofilter = true;
        this.initialize();
    }

    fetch() {
        return new Promise((resolve, reject) => {
            this.app.$api.getClients().then((data) => {
                gclients = data?.clients;
                resolve(gclients);
            }).catch(reject);
        });
    }

    valueAt(online, column) {
        switch (column) {
        case 0:
            if (online.user != undefined) {
                const user = this.app.$api.get_user(online.user);
                return {
                    user,
                };
            }
            return {};

        default:
            return super.valueAt(online, column);
        }
    }
}

export default {
    name: 'ClientsView',
    components: {
        TemplateContentView,
        TableView,
    },
    data() {
        return {
            controller: new ClientsController(this),
        };
    },
    mounted() {
        this.observer = (msg) => {
            const { action } = msg;
            if (action == 'login') {
                gclients.push(msg);
            } else if (action == 'logout') {
                for (let i = 0; i < gclients.length; i++) {
                    const client = gclients[i];
                    if (client.user == msg.user) {
                        if (client.client == msg.client) {
                            if (client.device == msg.device) {
                                if (client.ip == msg.ip) {
                                    if (client.authorized == msg.authorized) {
                                        gclients.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (action == 'reboot') {
                gclients = [];
            }
            const { controller } = this;
            controller.cache = markRaw(gclients);
            controller.initializeFilters();
            controller.searchTable();
        };
        this.$api.wsRegister('admin', this.observer);
    },
    unmounted() {
        this.$api.wsUnregister('admin', this.observer);
    },
};
</script>

<style scoped>
.caption {
    font-size: 1.75rem;
    align-self: center;
    padding-left: 16px;
}
</style>
